import React from 'react';
import { CONTRACT_18 } from '../../constants';

const CardBody = (props) => {
    return (
        <article className="card-body">
            <section className="ml-4">
                <b className="sub-heading font-heading-small">${props.monthlyPrice ? props.monthlyPrice + '/mth' : ''}</b>
                <p className="font-small mt-0 mb-3">
                {props.plan.special && props.plan.special.planPrice ? `for first ${props.plan.special.duration} then $${props.plan.price}/mth ongoing` : ''}                                
                </p>
                <p className="m-0 speed-info">{props.plan.planDownloadSpeed && props.plan.planUploadSpeed ? `nbn™  ${props.plan.planDownloadSpeed}/${props.plan.planUploadSpeed}`: ''}</p>
                <p className="m-0 mt-1 font-small">Typical business hour speed {props.plan.typicalEveningSpeed}</p>
                <div className="highlighted-info">Unlimited data</div>
                {props.plan.contract18 ? <p className="font-small my-2">{CONTRACT_18}</p> : ''}
            </section>
            <section className="feature-section">
                <div className="font-small px-4">
                    {props.plan.speedboost ?
                        <div className='sb-free-container bg-lightgrey ml-3 pt-5'>
                            <img src='/images/mini-boost.svg' alt='mini-boost' />
                            <p className='font-tiny m-0 semi-bold text-center'>
                                <a className='color-indigo underline' href='/speed-boost' target='_blank' rel='noreferrer'>My Speed Boost™</a> Eligible
                            </p>
                            <p className='font-tiny m-0 semi-bold text-center'>
                                5 Speed Upgrade Days per month included
                            </p>
                        </div>
                    : ''}
                    <ul className="pricing">
                        <li>5-minute support guarantee</li>
                        <li>Extended business hours support</li>
                        <li>Connection specialist</li>
                        <li>Static IP address</li>
                    </ul>
                </div>
            </section>
        </article>
    )
}

export default CardBody;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/card/CardBody.js